export default "__VITE_ASSET__BQ1rPGZd__"